export default {
  StorageTransactionReport: {
    header: {
      CustomerName: '客户名称',
      RecordDate: '记录日期'
    },
    table: {
      CustomerName: '客户名称',
      Storage: '存储量',
      Pallet: '托盘',
      creationDate: '日期'
    },
  }
};
